<template>
    <info-header-card :header="header" :badge="'test'" :rows="rows">
        <router-link
            v-if="userCreated"
            slot="User"
            :to="`/staff/${userCreated.getStaff().id}`"
        >{{userCreated.name}}</router-link>
        <router-link
            v-if="scheduled"
            slot="Scheduled"
            :to="`/schedules/${scheduled.id}`"
        >{{scheduled.date}}</router-link>
        <span slot="Status" slot-scope="{ row }">
            <result-export-status-badge :result_export="resultExport" />
        </span>
      <span slot="Tasks" slot-scope="{ value }">
        <b-badge class="mr-1" v-for="(task, index) in tasks" :key="index">
            {{ task.name }}
        </b-badge>
      </span>
    </info-header-card>
</template>
<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import ResultExportStatusBadge from "@/components/lab/resultexport/ResultExportStatusBadge";

export default {
    name: "ResultExportCard",
    components: { 
        InfoHeaderCard,
        ResultExportStatusBadge
    },
    props: {
        resultExport: {
            type: Object,
            default: () => null
        }
    },
    computed: {
        header() {
            return 'Export Detail';
            //return this.resultExport.id
        },
        userCreated() {
            return this.resultExport.getUser() ? this.resultExport.getUser() : null
        },
        scheduled() {
            return this.resultExport.getSchedule() ? this.resultExport.getSchedule() : null
        },
        tasks() {
            return this.resultExport.tasks;
        },
        rows() {
            return [
                {
                    label: "Code",
                    value: this.resultExport.code ? this.resultExport.code : "N/A"
                },
                {
                    label: "Status",
                    value: this.resultExport.status
                },
                {
                    label: "Laboratory",
                    value: this.resultExport.getLaboratory().name
                },
                {
                    label: "User",
                    value: this.userCreated.name
                },
                {
                    label: "Scheduled",
                    value: this.scheduled.date
                },
                {
                    label: "Sample Type",
                    value: this.resultExport.getSampleType().name
                },
                {
                    label: "Instrument",
                    value: this.resultExport.getInstrument().name
                },
                {
                    label: "Tasks",
                    value: this.tasks
                }
            ]
        }
    }
}
</script>